/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllMutatableEntityAssignmentsResponse } from '../../models/get-all-mutatable-entity-assignments-response';
import { UpdateMutatableEntityAssignmentsRequest } from '../../models/update-mutatable-entity-assignments-request';

export interface UpdateMutatableEntityAssignments$Params {
  organizationId: string;
  authorizedParty: string;
  
    /**
     * List of mutatable entity IDs to assign. Replaces all existing assignments.
     */
    body: UpdateMutatableEntityAssignmentsRequest
}

export function updateMutatableEntityAssignments(http: HttpClient, rootUrl: string, params: UpdateMutatableEntityAssignments$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllMutatableEntityAssignmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, updateMutatableEntityAssignments.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('authorizedParty', params.authorizedParty, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllMutatableEntityAssignmentsResponse>;
    })
  );
}

updateMutatableEntityAssignments.PATH = '/v1/organizations/{organizationId}/graphql/mutatableEntityAssignments/{authorizedParty}';
